// localStorage persistence helpers for TextAreaChat mesh-topology and
// polygon-override preferences. Pure, SSR-safe (guarded on `window`)
// read/write functions — no React. Extracted verbatim from the inline
// `useState` initializers and persist effects in TextAreaChat.

const MESH_TOPOLOGY_KEY = 'telekinesis-mesh-topology';
const POLYGON_OVERRIDES_KEY = 'telekinesis-polygon-overrides';

export const readStoredMeshTopology = (): 'quads' | 'polys' => {
  // Default to 'polys' (quads disabled by default)
  // Only use localStorage if it's explicitly set to 'quads'
  if (typeof window !== 'undefined') {
    const stored = localStorage.getItem(MESH_TOPOLOGY_KEY);
    // Only return 'quads' if explicitly stored, otherwise default to 'polys'
    return stored === 'quads' ? 'quads' : 'polys';
  }
  return 'polys';
};

export const writeStoredMeshTopology = (topology: 'quads' | 'polys'): void => {
  if (typeof window !== 'undefined') {
    localStorage.setItem(MESH_TOPOLOGY_KEY, topology);
  }
};

export const readStoredPolygonOverrides = (): Record<string, number> => {
  if (typeof window !== 'undefined') {
    try {
      const stored = localStorage.getItem(POLYGON_OVERRIDES_KEY);
      if (stored) {
        const parsed = JSON.parse(stored);
        // Validate that it's an object with number values
        if (typeof parsed === 'object' && parsed !== null) {
          const isValid = Object.entries(parsed).every(
            ([key, value]) =>
              typeof key === 'string' && typeof value === 'number',
          );
          return isValid ? parsed : {};
        }
      }
    } catch (error) {
      console.warn(
        'Failed to parse polygon overrides from localStorage, resetting:',
        error,
      );
      localStorage.removeItem(POLYGON_OVERRIDES_KEY);
    }
  }
  return {};
};

export const writeStoredPolygonOverrides = (
  overrides: Record<string, number>,
): void => {
  if (typeof window !== 'undefined') {
    localStorage.setItem(POLYGON_OVERRIDES_KEY, JSON.stringify(overrides));
  }
};
